module.exports = __webpack_public_path__ + "media/images/global/projects/project-plan-68822aa52a7c316aefe86204355bf917.png";